import React, { useState } from 'react';
import Icon from '../AppIcon';
import AppImage from '../AppImage';
import { useNavigate } from 'react-router-dom';
import { useScanlog } from 'contexts/scanlogContext';

const Header = ({ user, onMenuToggle, sidebarCollapsed }) => {
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const { openModalForQr } = useScanlog();
  const [qrSearchTerm, setQrSearchTerm] = useState("");
  const navigate = useNavigate()

  

  const handleLogout = () => {
    // Logout logic here
    localStorage.clear();
    navigate('/admin');
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && qrSearchTerm.trim() !== "") {
      openModalForQr(qrSearchTerm.trim());
      setQrSearchTerm("");
    }
  };


  return (
    // <header className="fixed top-0 left-0 right-0 h-header-height bg-surface border-b border-border z-50">
    <header className="fixed top-0 left-0 right-0 h-header-height bg-gradient-to-r from-[#006CB6] via-[#0095E8] to-[#00B8FF] dark:from-[#004E88] dark:via-[#005D9E] dark:to-[#0077C8] text-white backdrop-blur-md border-b border-white/10 shadow-md z-50 transition-all duration-300">

      <div className="flex items-center justify-between h-full px-6">
        {/* Left Section - Logo and Menu Toggle */}
        <div className="flex items-center space-x-4">
          <button
            onClick={onMenuToggle}
            className="lg:hidden p-2 rounded-lg hover:bg-primary-100 nav-transition"
            aria-label="Toggle menu" 
          >
            <Icon name="Menu" size={20} color="#2c3e50" />
          </button>
          
          <div className="flex items-center space-x-3">
            {/* <div className="w-20 bg-primary rounded-lg flex items-center justify-center"> */}
            <div className="w-20 overflow-hidden ring-1 ring-white/20 shadow-sm bg-white/10 backdrop-blur-sm">

              <AppImage
                src="/assets/images/logo.jpg"
                alt="Logo"                
              />
            </div>
            
          </div>
        </div>

        {/* Right Section - Search, User */}
        <div className="flex items-center space-x-4">
          {/* Global Search */}
          <div className="hidden md:flex items-center bg-white/20 backdrop-blur-md rounded-lg  px-3 border border-white/20 focus-within:ring-2 focus-within:ring-white/30 transition-all duration-200">
            <Icon name="Search" size={24} color="#fff" />
            <input
              type="text"
              placeholder="Search Qr Unique No..."
              className="bg-transparent border-none text-sm text-white placeholder:text-white focus:ring-0 outline-none flex-1"
              value={qrSearchTerm}
              onChange={(e) => setQrSearchTerm(e.target.value)}
              onKeyDown={handleKeyPress}
            />
          </div>

          
          {/* User Profile */}
          <div className="relative">
            <button
              onClick={() => setShowUserDropdown(!showUserDropdown)}
              className="flex items-center space-x-3 p-2 rounded-lg hover:bg-white/20 nav-transition transition-all duration-200"

              aria-label="User menu"
            >
              <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                <span className="text-primary text-sm font-medium">
                  {user?.name?.charAt(0) || 'U'}
                </span>
              </div>
              <div className="hidden lg:block text-left">
                <p className="text-sm font-medium text-white">{user?.company_name || 'User Name'}</p>
                <p className="text-xs text-white">{user?.role || 'Staff Member'}</p>
              </div>
              <Icon name="ChevronDown" size={16} color="#fff" />
            </button>

            {showUserDropdown && (
              <div className="absolute right-0 top-full mt-2 w-56 bg-surface rounded-lg shadow-floating border border-border z-dropdown">
                <div className="p-4 border-b border-border">
                  <p className="font-medium text-text-primary">{user?.company_name || 'User Name'}</p>
                  <p className="text-sm text-text-secondary truncate">{user?.email || 'user@company.com'}</p>
                  <span className="inline-block mt-2 px-2 py-1 bg-secondary-100 text-secondary-700 text-xs rounded-full">
                    {user?.role || 'Staff Member'}
                  </span>
                </div>
                <div className="py-2">
                  <button className="w-full px-4 py-2 text-left text-sm text-text-primary hover:bg-background nav-transition flex items-center space-x-3" onClick={()=> navigate("/profile-settings")}>
                    <Icon name="User" size={16} color="#7f8c8d" />
                    <span>Profile Settings</span>
                  </button>
                </div>
                <div className="border-t border-border py-2">
                  <button
                    onClick={handleLogout}
                    className="w-full px-4 py-2 text-left text-sm text-error hover:bg-error-100 nav-transition flex items-center space-x-3"
                  >
                    <Icon name="LogOut" size={16} color="#e74c3c" />
                    <span>Sign Out</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;